import {FormControl, FormHelperText, FormLabel, Input} from "@mui/joy";
import {useFormContext} from "react-hook-form";

export function FormInput({ name, label, type, size, optional, placeholder, variant='outlined', inputProps, endDecorator, startDecorator, sx, onPaste }) {
  const { register, formState, getFieldState } = useFormContext();    
  const error = getFieldState(name, formState).error;

  return (
    <FormControl error={!!error} sx={sx}>
      {label &&<FormLabel>{label} {optional && <span style={{ color: 'var(--joy-palette-neutral-400)' }}>(optional)</span>}</FormLabel>}
      <Input {...register(name)} type={type || "text"} size={size} variant={variant} placeholder={placeholder} slotProps={inputProps ? {input: inputProps} : undefined} endDecorator={endDecorator} startDecorator={startDecorator} onPaste={onPaste} />
      {error && <FormHelperText sx={{ ml: variant === 'plain' ? 1.5 : 0 }}>{error.message}</FormHelperText>}
    </FormControl>
  );
}